module.exports = __webpack_public_path__ + "static/fiji3-300x249-9b7960685b2fd8f203def3383c8902b4.png";